"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { initPosthog } from "@/lib/posthogClient";
import { Analytics } from "@vercel/analytics/react";
import { analytics } from "@/lib/analyticsClient";

export default function AnalyticsProvider() {
  const pathname = usePathname();

  useEffect(() => {
    // Initialize PostHog after component mounts (non-blocking)
    // Use requestIdleCallback if available, otherwise setTimeout
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      requestIdleCallback(() => {
        initPosthog();
      }, { timeout: 2000 });
    } else {
      // Fallback: initialize after a short delay to avoid blocking page load
      setTimeout(() => {
        initPosthog();
      }, 100);
    }
  }, []);

  // Track page views when pathname changes
  useEffect(() => {
    if (pathname) {
      // Track page view with current path
      analytics.pageView(pathname, {
        // Include referrer if available
        referrer: typeof document !== 'undefined' ? document.referrer : undefined,
      });
    }
  }, [pathname]);

  return <Analytics />;
}

